import { createSlice } from '@reduxjs/toolkit';

import { initialStore } from '../initial-store';

const providersSlice = createSlice({
  initialState: initialStore.providersPage,
  name: 'providersPage',
  reducers: {
    getProviders: (state) => {
      state.isLoading = true;
    },
    getProvidersError: (state) => {
      state.isLoading = false;
    },
    setProviders: (state, { payload }) => {
      const { count, result } = payload;
      state.data = result;
      state.count = count;
      state.isLoading = false;
    },
    updateProvider: (state, { payload }) => {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    }
  }
});

export const { getProviders, getProvidersError, setProviders, updateProvider } =
  providersSlice.actions;

export const { reducer } = providersSlice;
